<script lang="ts" setup>
  import { computed, ref } from 'vue';
  import { useShared, useAuthenticated, useHttpClient, useRoute } from '@othercommerce/foundation';

  const emit = defineEmits([
    'saved',
  ]);

  const props = defineProps({
    variant: { type: Number, required: true },
  });

  const route = useRoute();
  const shared = useShared();
  const http = useHttpClient();
  const session = useAuthenticated();
  const create = ref(false);

  const options = computed(() => {
    return shared.value.wishlists || [];
  });

  const initial = computed(() => {
    return { wishlist: options.value[0]?.value || null };
  });

  function onSubmit(data: { wishlist: string }) {
    return http.post(route('web.account.wishlist.variant.store', { wishlist: data.wishlist }), { variant: props.variant }).then(() => emit('saved'));
  }
</script>
<template>
  <FormController :data="initial" @submit="onSubmit" v-slot="{ data, processing, submit }" class="wishlist-picker">
    <section class="wishlist-picker__wrapper">
      <div v-if="session">
        <template v-if="options.length >0">
          <SfFormSelect :label="$t('SHOP.WISHLIST.LABEL.SELECT_LIST')" :options="options" name="wishlist" required />
        </template>
        <template v-else>
          <p>{{ $t('SHOP.WISHLIST.LABEL.NO_LIST_AVAILABLE') }}</p>
        </template>
      </div>
      <SfDataPlaceholder v-else>
        {{ $t('SHOP.WISHLIST.LABEL.WISHLIST_AUTHENTICATION_NOTICE') }}
      </SfDataPlaceholder>
    </section>
    <footer class="wishlist-picker__footer">
      <template v-if="session">
        <SfButton @click.prevent="create = true" aria-haspopup="dialog" aria-controls="wishlist-create-modal">
          <template #before>
            <SfIconPlus aria-hidden="true" />
          </template>
          {{ $t('SHOP.WISHLIST.ACTION.CREATE_NEW_LIST') }}
        </SfButton>
        <SfButton :disabled="!data.wishlist" :loading="processing" primary type="submit" @click="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </template>
      <template v-else>
        <SfButton :href="$route('web.account.session.create')" primary>
          {{ $t('SHOP.AUTH.ACTION.SIGN_IN') }}
        </SfButton>
      </template>
    </footer>
  </FormController>
  <WishlistEditModal v-model:open="create" @saved="create = false" id="wishlist-create-modal" />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .wishlist-picker {
    &__wrapper {
      margin: 1rem 0;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
    }
  }

  @include media.query(md) {
    .wishlist-picker__wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex-grow: 1;
    }
  }
</style>
